import { hasCapability } from "@/utils/capability";

import { useActiveScopeCapabilities } from "../capability/useActiveScopeCapabilities";

/**
 * Coach surfaces (`COACH:READ` to see, `COACH:WRITE` to manage) checked against
 * the active scope's capability set. Strict RBAC — the backend resolver is the
 * single source of truth and the S0 grants give every legacy member the matching
 * keys. See docs/capabilities.md.
 */
export const useCoachPermissions = () => {
  const { capabilities } = useActiveScopeCapabilities();

  const canSeeCoaches = hasCapability(capabilities, "COACH:READ");
  const canManageCoaches = hasCapability(capabilities, "COACH:WRITE");

  return { canSeeCoaches, canManageCoaches };
};
